<template>
  <a-modal
    v-model:visible="visible"
    wrap-class-name="modal-multiple-languages"
    title="多语言"
    :width="modalPage === 'chooseLanguagePage' ? 300 : 900"
    :footer="modalPage === 'chooseLanguagePage' ? undefined : null"
    :after-close="afterClose"
  >
    <div
      v-if="
        modalPage === 'chooseLanguagePage' &&
        canUse('choose-defualt-lang').valid &&
        ElectronApi.isProfessional()
      "
      class="mb-4"
    >
      <div class="mb-2 text-[16px] ml-4">设备类型</div>
      <a-radio-group :value="deviceRegion" class="ml-8">
        <a-radio
          v-for="item in defaultLangOptions"
          :key="item.value"
          :value="item.value"
          @change="
            updateDefaultLang(item.value as 'domestic' | 'international')
          "
          >{{ item.label }}</a-radio
        >
      </a-radio-group>
    </div>
    <!-- 选择语言页面 -->
    <div v-if="modalPage === 'chooseLanguagePage'">
      <div v-if="canUse('choose-defualt-lang').valid" class="ml-4 text-[16px]">
        选择语言
      </div>
      <div class="h-72 overflow-auto">
        <div v-for="(item, key) in options" :key="key">
          <div
            class="w-full h-9 flex justify-between items-center pl-[30px] pr-[30px]"
            :class="{
              'hover:bg-black-50': !item.disabled,
              'opacity-50': item.disabled
            }"
            @click="
              !item.disabled && getSelection(item.value as TranslationLocale)
            "
          >
            <span>{{ item.label }}</span>
            <span
              v-if="
                translationStore.locales.includes(
                  item.value as TranslationLocale
                )
              "
            >
              <icon icon="tick_mark.svg" :width="14" :height="14" fill="none"
            /></span>
          </div>
        </div>
      </div>
      <!-- 分割线 -->
      <div v-if="selectedLocales.length" class="h-[1px] bg-black-50 mb-2"></div>
      <div class="max-h-15 w-full overflow-auto mt-5 px-[30px]">
        <div class="flex flex-wrap gap-[5px] gap-y-2">
          <div
            v-for="(item, key) in selectedLocales"
            :key="key"
            class="p-[10px] h-[26px] bg-black-50 rounded-[4px] flex items-center justify-center"
          >
            <span class="text-xs">{{ LANGUAGES[item] }} </span>
            <span class="pl-[6px]" @click="handleClick(item)">
              <icon icon="delete2.svg" :width="12" :height="12" fill="none" />
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 表盘名称和表达式页面 -->
    <div v-if="modalPage !== 'chooseLanguagePage'" class="flex">
      <div class="w-[140px] h-[527px] mr-6 relative">
        <div
          v-for="(item, key) in menu"
          :key="key"
          class="h-[60px] text-[20px] leading-10 px-5 ml-4 mb-[10px] pt-[10px] opacity-[0.7] hover:bg-[#333]/[0.5] rounded-[6px] w-[140px]"
          :class="{
            'bg-[#333333]  opacity-[1.0]': item.selected
          }"
          @click="select(item)"
        >
          {{ item.title }}
        </div>
        <a-button
          type="primary"
          class="absolute bottom-6 ml-8"
          style="width: 100px"
          @click="onAdd"
        >
          添加语言
        </a-button>
      </div>
      <div
        class="ml-5 w-[716px] max-h-[527px] px-5 pt-[10px] rounded-2xl overflow-y-auto bg-[#1e1e1e]"
        style="border-bottom-left-radius: 0"
      >
        <!-- 表盘名称 -->
        <template v-if="modalPage === 'watchfaceNamePage'">
          <a-form
            :label-col="{ span: 3 }"
            :label-align="'left'"
            class="pl-5 pr-5 pt-4"
          >
            <a-form-item label="表盘名称">
              <a-input
                :value="watchfaceStore.description.name"
                style="border: transparent"
              />
            </a-form-item>
            <a-form-item
              v-for="(language, key) in translationStore.locales.filter(
                (i) => i !== defaultLanguage
              )"
              :key="key"
              :label="LANGUAGES[language]"
            >
              <a-input
                v-model:value="
                  translationStore.translations['watchfaceName'][language]
                "
                placeholder="请输入对应语言文字"
                @change="
                  translationStore.setTranslation(
                    'watchfaceName',
                    language,
                    translationStore.translations['watchfaceName'][
                      language
                    ] as string
                  )
                "
              />
            </a-form-item>
          </a-form>
        </template>
        <!-- 表达式 -->
        <!-- <template v-if="modalPage === 'expressionPage'">
          <div v-if="!widgetArr.length" class="ml-[278px] mt-50 text-xl">
            暂无内容
          </div>
          <a-form
            v-for="(item, key1) in widgetArr"
            :key="key1"
            :label-col="{ span: 3 }"
            :label-align="'left'"
            class="pl-5 pr-5 pt-4 mb-3"
          >
            <a-form-item :label="item.label">
              <a-input v-model:value="item.attr" style="border: transparent" />
            </a-form-item>
            <a-form-item
              v-for="(language, key2) in selectedLocales"
              :key="key2"
              :label="LANGUAGES[language]"
            >
              <a-input
                v-model:value="translationStore.translations[item.id][language]"
                placeholder="请输入对应语言文字"
                @change="
                  translationStore.setTranslation(
                    item.id,
                    language,
                    translationStore.translations[item.id][language] as string
                  )
                "
              />
            </a-form-item>
          </a-form>
        </template> -->
        <!-- 文本 -->
        <!-- <template v-if="modalPage === 'textPage'">
          <a-form
            v-for="(item, key1) in textArr"
            :key="key1"
            :label-col="{ span: 3 }"
            :label-align="'left'"
            class="pl-5 pr-5 pt-4 mb-3"
          >
            <a-form-item :label="item.label" name="textPage">
              <a-input v-model:value="item.attr" style="border: transparent" />
            </a-form-item>
            <a-form-item
              v-for="(language, key2) in translationStore.locales.filter(
                (i) => i !== 'zh_CN'
              )"
              :key="key2"
              :label="LANGUAGES[language]"
            >
              <a-input
                v-model:value="text[key1][key2]"
                placeholder="请输入对应语言文字"
                @change="
                  translationStore.setTranslation(
                    item.label,
                    language,
                    text[key1][key2]
                  )
                "
              />
            </a-form-item>
          </a-form>
        </template> -->
      </div>
    </div>
    <template #footer>
      <a-button class="mr-3" @click="onCancel">取消 </a-button>
      <a-button type="primary" @click="onOk"> 确定 </a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import {
  getLanguages,
  TranslationLocale,
  useTranslationStore
} from '@/store/use-translation-store';
import { useWatchfaceStore } from '@/store/use-watchface-store';
import { useLayerStore } from '@/store/use-layer-store';
import { numberToChinese } from '@/utils/handle-number';
import cloneDeep from 'lodash-es/cloneDeep';
import { canUse } from '@/utils/can-use.utils';
import { ElectronApi } from '@/services/electron.api';

const watchfaceStore = useWatchfaceStore();
const translationStore = useTranslationStore();
const visible = ref(false);
type PageType =
  | 'chooseLanguagePage'
  | 'watchfaceNamePage'
  | 'expressionPage'
  | 'textPage';
const modalPage = ref<PageType>('chooseLanguagePage');
const copySelectedLocales = ref<TranslationLocale[]>([]);
const deviceRegion = computed(
  () => watchfaceStore.description.deviceRegion ?? 'domestic'
);

const defaultLanguage = computed(() =>
  watchfaceStore.description.deviceRegion === 'international'
    ? 'en_US'
    : 'zh_CN'
);
defineExpose({
  open: () => {
    visible.value = true;
    if (selectedLocales.value.length) {
      modalPage.value = lastPage.value;
    }
    copySelectedLocales.value = cloneDeep(translationStore.locales);
    translationStore.setLocales([
      defaultLanguage.value,
      ...selectedLocales.value
    ]);
    if (!Object.keys(translationStore.translations).includes('watchfaceName')) {
      translationStore.addTranslation('watchfaceName');
    }
    translationStore.setTranslation(
      'watchfaceName',
      defaultLanguage.value,
      watchfaceStore.description.name
    );
  }
});

const selectedLocales = computed(() =>
  translationStore.locales.filter((i) => i !== defaultLanguage.value)
);

const LANGUAGES = ref(getLanguages());

const options = computed(() => {
  const originalLangEntries = Object.entries(getLanguages());
  let langEntries: [string, string][] = [...originalLangEntries];
  const supprtBulgaria = canUse('support-new-language-bulgaria').valid;
  const supprtLithuanian = canUse('support-new-language-lithuanian').valid;
  if (!supprtBulgaria && !supprtLithuanian) {
    // 都不支持：删除最后两个元素（直接截取到倒数第 2 位之前）
    langEntries = originalLangEntries.slice(0, -2);
  } else if (!supprtBulgaria) {
    // 只不支持保加利亚语：删除最后一位
    langEntries = originalLangEntries.slice(0, -1);
  } else if (!supprtLithuanian) {
    // 只不支持立陶宛语：删除倒数第二位（拼接 前 n-2 位 + 最后 1 位）
    langEntries = [
      ...originalLangEntries.slice(0, -2),
      ...originalLangEntries.slice(-1)
    ];
  }

  return langEntries.map((lang) => ({
    value: lang[0],
    label: lang[1],
    disabled: lang[0] === defaultLanguage.value
  }));
});

const getSelection = (value: TranslationLocale) => {
  if (translationStore.locales.includes(value)) {
    translationStore.locales.splice(translationStore.locales.indexOf(value), 1);
  } else {
    translationStore.locales.push(value);
  }
};
const handleClick = (value: TranslationLocale) => {
  translationStore.locales.splice(translationStore.locales.indexOf(value), 1);
};

const lastPage = ref<PageType>('watchfaceNamePage');
const onOk = () => {
  translationStore.setLocales([
    defaultLanguage.value,
    ...selectedLocales.value
  ]);
  modalPage.value = lastPage.value;
};

const onCancel = () => {
  translationStore.setLocales(copySelectedLocales.value);
  visible.value = false;
};
const menu = ref<{ title: string; selected: boolean; modalPage: string }[]>([
  { title: '表盘名称', selected: true, modalPage: 'watchfaceNamePage' }
  // { title: '组', selected: false, modalPage: 'expressionPage' }
  // { title: '文本', selected: false, modalPage: 'textPage' }
]);

const onAdd = () => {
  lastPage.value = modalPage.value;
  copySelectedLocales.value = cloneDeep(translationStore.locales);
  modalPage.value = 'chooseLanguagePage';
};
const select = (item: {
  title: string;
  selected: boolean;
  modalPage: string;
}) => {
  menu.value.forEach((menuItem) => {
    if (item.title === menuItem.title) menuItem.selected = true;
    else menuItem.selected = false;
  });
  modalPage.value = item.modalPage as PageType;
};

const layerStore = useLayerStore();
const findNodesWithWidget = (tree: StoreLayerItem[]) => {
  let result: StoreLayerItem[] = [];
  const traverse = (node: StoreLayerItem[]) => {
    for (let value of node) {
      if (value.type == 'Widget') result.push(value);
      else {
        if (value.children?.length) traverse(value.children);
      }
    }
  };
  traverse(tree);
  return result;
};

const widgetArr = computed(() => {
  const tree = layerStore.themes[0].children;
  const _widgetArr = findNodesWithWidget(tree).map((item, key) => {
    return {
      id: item.id,
      label: '组' + numberToChinese(+key + 1),
      attr: item.attrs.name
    };
  });
  _widgetArr.forEach((item) => {
    if (!Object.keys(translationStore.translations).includes(item.id)) {
      translationStore.addTranslation(item.id);
    }
    translationStore.setTranslation(item.id, defaultLanguage.value, item.attr);
  });
  return _widgetArr;
});

// const layerStore = useLayerStore();
// const textArr = computed(() => {
//   const tree = layerStore.themes[0].children;
//   const findNodesWithText = (tree: StoreLayerItem[]) => {
//     let result: StoreLayerItem[] = [];
//     const traverse = (node: StoreLayerItem[]) => {
//       for (let value of node) {
//         if (value.type == 'Text') result.push(value);
//         else {
//           if (value.children?.length) traverse(value.children);
//         }
//       }
//     };
//     traverse(tree);
//     return result;
//   };
//   const _textArr = findNodesWithText(tree).map((item) => {
//     if (!item.attrs.strings[0].isSource) return item.attrs.strings[0].value;
//   });
//   //去重
//   const uniqueTextArr = [...new Set(_textArr)].map((item, key) => ({
//     label: '文本' + numberToChinese(+key + 1),
//     attr: item
//   }));
//   uniqueTextArr.forEach((item) => {
//     if (!Object.keys(translationStore.translations).includes(item.label))
//       translationStore.addTranslation(item.label);
//     translationStore.setTranslation(item.label, 'zh_CN', item.attr);
//   });
//   // console.log(tree);
//   return uniqueTextArr;
// });

const afterClose = () => {
  if (!selectedLocales.value.length) modalPage.value = 'chooseLanguagePage';
  else {
    menu.value.forEach((item) => {
      if (item.selected) lastPage.value = item.modalPage as PageType;
    });
  }
  const Id = widgetArr.value.map((item) => item.id);
  Id.push('watchfaceName');
  // for (let key in translationStore.translations) {
  //   if (!Id.includes(key)) {
  //     translationStore.removeTranslation(key);
  //     Shape.getShape(key)?.setAttrs({ widgetName: '' });
  //   }
  //   if (key !== 'watchfaceName')
  //     Shape.getShape(key)?.setAttrs({ widgetName: '@' + key });
  //   // console.log(Shape.getShape(key)?.attrs.widgetName);
  // }
  translationStore.save();
  // console.log(translationStore.$state.translations);
};

const defaultLangOptions = computed(() => {
  return [
    {
      label: '国内',
      value: 'domestic'
    },
    {
      label: '国外',
      value: 'international'
    }
  ];
});

const updateDefaultLang = async (val: 'domestic' | 'international') => {
  await watchfaceStore.update({
    deviceRegion: val
  });
  translationStore.setLocales([defaultLanguage.value]);
  for (let key in translationStore.translations) {
    translationStore.removeTranslation(key);
  }
  translationStore.addTranslation('watchfaceName');
  translationStore.setTranslation(
    'watchfaceName',
    defaultLanguage.value,
    watchfaceStore.description.name
  );
};
</script>
<style lang="less">
.modal-multiple-languages {
  .ant-modal-content {
    border-radius: 10px;
    background-color: #000000;
    .ant-modal-header {
      border-radius: 10px 10px 0 0;
      background-color: #000000;
      .ant-modal-title {
        font-weight: 400;
      }
    }
    .ant-modal-body {
      padding: 0;
      padding-top: 20px;
      .ant-form-item-control-input-content {
        margin-bottom: 5px;
        .ant-input {
          font-size: 14px;
          border: 1px solid rgba(255, 255, 255, 0.2);
        }
      }
    }
    .ant-modal-footer {
      padding-top: 1rem;
      padding-bottom: 2rem;
    }
  }
}
</style>
<style scoped lang="less">
._sendto p {
  margin-bottom: 8px;
}
:deep(.ant-form-item-label > label::after) {
  content: '';
}
</style>
